<template>
  <!-- Profile Information Card -->
  <a-card :bordered="false" class="header-solid h-full card-profile-information"
    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }" :headStyle="{ paddingRight: 0 }" style="height: 700px">
    <a-list class="mt-25 mb-20" item-layout="horizontal">
      <a-list-item>
        <a-list-item-meta>
          <span slot="title" href="https://newmy.muic.io/">
            <h6 class="mr-10 mt-20 mb-0">{{ profile.staffId }}</h6>
            <p class="mr-10 mt-0 mb-0 text-dark">{{ profile.fullname_eng }}</p>
            <small class="mr-10 text-muted font-web">{{
              profile.fullname_thai
              }}</small>
          </span>
          <div slot="avatar">
            <a-avatar shape="square" style="width: 100%; height: 100px" :src="`${profile.urlPic}`"></a-avatar>
          </div>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
    <a-descriptions :column="1">

      <a-descriptions-item label="">
        <p class="mt-0 mb-10 text-muted">Position:</p>
        <p class="font-semibold m-0">{{ profile.fullposition_eng }}</p>
        <small class="text-muted font-web">{{
          profile.fullposition_thai
          }}</small>
      </a-descriptions-item>
      <a-descriptions-item label="">
        <p class="mt-0 mb-10 text-muted">Department:</p>
        <p class="font-semibold m-0">{{ profile.fulldepartment_eng }}</p>
        <small class="text-muted font-web">{{
          profile.fulldepartment_thai
          }}</small>
        <span v-if="profile.department_detail_thai !== profile.fulldepartment_thai">
          <p class="font-semibold mt-10 mb-0">
            {{ profile.department_detail_eng }}
          </p>
          <small class="text-muted font-web">{{
            profile.department_detail_thai
            }}</small>
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Office phone">
        {{ profile.fullposition_eng === 'Aj.parttime' ? '-' : profile.telephone }}
      </a-descriptions-item>
      <a-descriptions-item label="Email">
        <a v-if="profile.fullposition_eng !== 'Aj.parttime'" class="" :href="'mailto:' + profile.email">{{ profile.email
          }}</a>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item label="Update at">
        <p class="font-semibold mt-5 mb-0">
          {{ moment(profile.updated_at).format("DD / MMM / YYYY hh:mm:ss") }}
        </p>
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
  <!-- / Profile Information Card -->
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>
